var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{attrs:{"width":"lg"}},[_c('HeaderSection',{attrs:{"header":_vm.slice.primary.header}}),_vm._v(" "),_c('ul',_vm._l((_vm.posts),function(post,index){return _c('LatestNewsLink',{key:index,attrs:{"post":post}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }